import { useContext } from 'react';
import './style.css'
import React from 'react';
import { popupContext } from '../../../contextAdmin/Admin/Popup';

// Creator : Team E - Chanan
function Popup() {
    const { popup, setPopup } = useContext(popupContext)

    const closePopup = () => setPopup()


    return (
        <div className='layout' >
            <div className='popup-inbox two-colored-div'>
                <div className='popup-header'>
                    {popup.props.children}
                    <div onClick={closePopup} className='popup-close'>
                        <img src={require('./x.png')} alt="close" />
                    </div>
                </div>
                {popup}
            </div>
        </div>)

}

export default Popup